/* assets/cart-gift-cta.js — CTA on /cart page to open the quick cart (3 tiers) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);

  // FIX #7: Thresholds (and per-tier max gift counts) are read from data
  // attributes written by main-cart.liquid onto .cart__choose-gifts, so
  // changing them in one place keeps everything in sync.
  function getConfig() {
    const container = $('.cart__choose-gifts');
    if (!container) return { gift1: 3500, gift2: 5000, gift3: 8000, max1: 1, max2: 2, max3: 3 };
    return {
      gift1: parseInt(container.dataset.gift1Threshold || '3500', 10),
      gift2: parseInt(container.dataset.gift2Threshold || '5000', 10),
      gift3: parseInt(container.dataset.gift3Threshold || '8000', 10),
      max1:  parseInt(container.dataset.max1 || '1', 10),
      max2:  parseInt(container.dataset.max2 || '2', 10),
      max3:  parseInt(container.dataset.max3 || '3', 10)
    };
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function openQuickCart() {
    // Method 1: click the header cart icon
    const headerCart = $(
      '.header__cart button, ' +
      '.header__cart a[href="/cart"], ' +
      '.header__cart a[href="#"], ' +
      '.site-header__cart, ' +
      '[data-header-cart], ' +
      '.js-drawer-open-cart'
    );
    if (headerCart) { headerCart.click(); return true; }

    // Method 2: dispatch common theme events
    const customEvents = [
      'theme:cart:open',
      'cart:open',
      'drawer:open',
      'modal:open:quick-cart'
    ];
    for (const eventName of customEvents) {
      document.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true,
        detail: { source: 'cart-page' }
      }));
    }

    // Method 3: manually open the drawer
    const drawer  = $('.quick-cart');
    const overlay = $('.quick-cart__overlay');

    if (drawer) {
      drawer.classList.add('is-visible', 'is-open', 'open', 'active');
      drawer.style.transform  = 'translateX(0)';
      drawer.style.visibility = 'visible';

      if (overlay) {
        overlay.classList.add('is-visible');
        overlay.style.visibility = 'visible';
        overlay.style.opacity    = '1';
      }

      document.documentElement.classList.add('scroll-lock', 'no-scroll');
      document.body.classList.add('scroll-lock', 'no-scroll');
      document.body.style.overflow = 'hidden';

      drawer.setAttribute('aria-hidden', 'false');
      drawer.setAttribute('tabindex', '-1');
      setTimeout(() => drawer.focus(), 100);

      return true;
    }

    return false;
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
  }

  async function syncCta() {
    const container = $('.cart__choose-gifts');
    if (!container) return;

    try {
      const cart = await fetchCart();
      const cfg  = getConfig();
      const { gift1: GIFT1, gift2: GIFT2, gift3: GIFT3, max1: MAX1, max2: MAX2, max3: MAX3 } = cfg;

      let subtotalExGifts = 0;
      let giftCount = 0;

      (cart.items || []).forEach(i => {
        if (i?.properties?._gift === 'true') {
          giftCount += i.quantity;
        } else {
          subtotalExGifts += i.final_line_price;
        }
      });

      if (subtotalExGifts < GIFT1) {
        // Below tier 1 — no gifts yet
        const moneyNeeded = GIFT1 - subtotalExGifts;
        container.innerHTML = `
          <p class="fs-body-100" style="color: var(--color-text-subdued, #666);">
            Spend <strong>${formatMoney(moneyNeeded)}</strong> more to claim your free gift
          </p>
        `;
      } else if (subtotalExGifts < GIFT2) {
        // Tier 1 — up to MAX1 gift(s)
        const atMax       = giftCount >= MAX1;
        const moneyNeeded = GIFT2 - subtotalExGifts;
        container.innerHTML = `
          <button
            type="button"
            class="btn btn--secondary"
            data-open-gifts
            ${atMax ? 'disabled aria-disabled="true"' : ''}
          >
            ${atMax ? (MAX1 > 1 ? 'Gifts selected' : 'Gift selected') : (MAX1 > 1 ? 'Choose gifts' : 'Choose gift')}
          </button>
          ${!atMax
            ? `<p class="fs-body-75 t-subdued" style="margin-top:6px">
                Spend <strong>${formatMoney(moneyNeeded)}</strong> more to unlock another gift
               </p>`
            : `<p class="fs-body-75 t-subdued" style="margin-top:6px">
                Click the button above to select your free gift
               </p>`
          }
        `;
      } else if (subtotalExGifts < GIFT3) {
        // Tier 2 — up to MAX2 gifts
        const atMax       = giftCount >= MAX2;
        const moneyNeeded = GIFT3 - subtotalExGifts;
        container.innerHTML = `
          <button
            type="button"
            class="btn btn--secondary"
            data-open-gifts
            ${atMax ? 'disabled aria-disabled="true"' : ''}
          >
            ${atMax ? 'Gifts selected' : 'Choose gifts'}
          </button>
          <p class="fs-body-75 t-subdued" style="margin-top:6px">
            ${atMax
              ? `Spend <strong>${formatMoney(moneyNeeded)}</strong> more to unlock even more gifts`
              : `Click the button above to select your free gifts — spend <strong>${formatMoney(moneyNeeded)}</strong> more to unlock even more`}
          </p>
        `;
      } else {
        // Tier 3 — up to MAX3 gifts
        const atMax = giftCount >= MAX3;
        container.innerHTML = `
          <button
            type="button"
            class="btn btn--secondary"
            data-open-gifts
            ${atMax ? 'disabled aria-disabled="true"' : ''}
          >
            ${atMax ? 'Gifts selected' : 'Choose gifts'}
          </button>
          <p class="fs-body-75 t-subdued" style="margin-top:6px">
            Click the button above to select your free gifts
          </p>
        `;
      }
    } catch (e) {
      console.error('syncCta failed:', e);
    }
  }

  // Click handler (event delegation — survives innerHTML replacement)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-open-gifts]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    openQuickCart();
  }, true);

  // Sync after cart mutations (only external ones — this file has no internal writes)
  try {
    const _fetch = window.fetch;
    window.fetch = function (...args) {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);
      const isCartMutation = /\/cart\/(add|change|update)\.js(\?|$)/.test(url || '');
      const p = _fetch.apply(this, args);
      if (isCartMutation) p.then(() => setTimeout(syncCta, 200)).catch(() => {});
      return p;
    };
  } catch {}

  ['cart:updated', 'theme:cart:change'].forEach(ev => {
    document.addEventListener(ev, () => setTimeout(syncCta, 200));
  });

  document.addEventListener('DOMContentLoaded', syncCta);
  setTimeout(syncCta, 500);
})();
